import React, { useState } from 'react'
import { IRequestedItem, IRequestedItemAllocation, ItemsRequestModel } from '.'
import { Avatar, Button, TextField } from '@mui/material'
import SelectItems from '../items/SelectItems'
import BasicModalWindow from '../../components/BasicModalWIndow'
import ItemsApp, { IItemModel } from '../items/ItemsApp'
import GenerateIcon from '../../components/GenerateIcon'
import ItemAllocations from './ItemAllocations'
import RequestedItemAllocations from './RequestedItemAllocations'
import RequestItemSubItems from './RequestItemSubItems'
import SectionBoxContainer from '../../components/SectionBoxContainer'
import NoThumb from "../../assets/svg/no-thumb.svg"
import { useLocation } from 'react-router-dom'
import CreateNewIssue from '../issues/CreateNewIssue'
import QuantitySlider from '../transactions/QuantitySlider'
import ItemsRequestsApp, { EmptyItemRequestModel } from './ItemsRequestsApp'
import { useReturnCurrentUser } from '../user/userSlice'
import { handleRequestError } from '../../services/api'
import { useDispatch } from 'react-redux'
import AlertElement from '../../components/AlertElement'
import SelectItemsForRequest from './SelectItemsForRequest'
import { ISelectedItemForRequestModel } from './SelectedItemForRequest'
import { error } from 'console'
import { handleCloseElementQuickPreview, handleOpenElementQuickPreview } from '../admin/adminPagesSlice'
import Thumbnail from '../../components/Thumbnail'


interface IRequestedItemProps {
    requestedItems: IRequestedItem[],
    requestedItem: IRequestedItem,
    deleteItem: (id: number) => void,
    setItems: (items: IRequestedItem[]) => void,
    updateAllocationsForItem: (itemId: number, updatedAllocation: IRequestedItemAllocation) => void,
    removeAllocationForItem: (itemId: number, warehouseId: number, sectionId: number) => void,
    viewRequestPage?: boolean,
    isItemRequestPage?: boolean,
    showReport: (requestedItem: IRequestedItem, allocation: IRequestedItemAllocation) => void,
    request?: ItemsRequestModel | null,
    handleShowRejectItem: (itemId: number) => void,
    forceRefreshRequest?: (status: boolean) => void,
    hideAllocations?: boolean,
    hideContainedItems?: boolean,
}
export function RequestedItem(props: IRequestedItemProps){

    const dispatch = useDispatch()

    const { 
        requestedItem, 
        requestedItems, 
        deleteItem, 
        setItems, 
        updateAllocationsForItem, 
        removeAllocationForItem, 
        viewRequestPage, 
        isItemRequestPage, 
        showReport, 
        request, 
        handleShowRejectItem, 
        forceRefreshRequest,
        hideAllocations,
        hideContainedItems,
    } = props
    const { item_id, item, allocations, quantity, damaged, missing } = requestedItem

    const [open, setOpen] = useState<boolean>(false)

    const [note, setNote] = useState<string>("")
    const [returnItemModal, setReturnItemModal] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)

    const currentUser = useReturnCurrentUser()

    const itemsRequestApp = new ItemsRequestsApp()

    if (item.parent_item){
        return <></>
    }

    let showReportButton: boolean = false
    let showRejectButton = false
    let showReturnButton = false
    let isReturnAvailbale = true

    if (request?.status === "fulfilled"){
        showReportButton = true
    }

    if (request?.status === "returned"){
        showReportButton = true
    }

    if (request?.status === "pending"){
        if (currentUser.is_superuser){
            showRejectButton = true
        }
    }

    if (requestedItem.missing > 0){
        isReturnAvailbale = false
    }

    if (requestedItem.is_returned){
        isReturnAvailbale = false
    }

    if (request){
        switch(request.status){

            case "fulfilled":
                showReturnButton = true

        }
    }
    
    const closeReturnModal = () => {
        setReturnItemModal(false)
    }

    const handleReturnItem = () => {
        if (!request){
            return;
        }

        setLoading(true)

        itemsRequestApp.returnRequestedItems(
            request?.request_number,
            note,
            true,
            requestedItem.item_id,
            true
        )
            .then(response => {
                if (forceRefreshRequest){
                    forceRefreshRequest(true)
                }
                setLoading(false)
                setReturnItemModal(false)
            })
            .catch(error => {
                handleRequestError(error, dispatch)
                setLoading(false)
                setReturnItemModal(false)
            })


    }

    /**
     * Render Action Buttons
     */
    const renderActionButtons = () => {

        const manageButtons = () => {
            return(
                <>
                    <Button disabled={item.is_container ? true : false} className="general-button admin-button" color="success" onClick={() => setOpen(true)}>Update Quantity</Button>
                    <Button className="general-button admin-button" color="error" onClick={() => deleteItem(item_id)}>Delete</Button>
                </>
            )
        }

        if (!viewRequestPage){
            return manageButtons()
        }else{

            if (request){
                if (request.status === "pending"){
                    return manageButtons()
                }
            }

            return(
                <>
                    {showReturnButton && <Button disabled={isReturnAvailbale ? false : true} className="general-button admin-button" color="success" onClick={() => setReturnItemModal(true)}>Return</Button>}
                    {showRejectButton && <Button disabled={requestedItem.is_rejected} className="general-button admin-button" color="error" onClick={() => handleShowRejectItem(requestedItem.item_id)}>Reject</Button>}
                </>
            )
        }

        return <></>
    }

    return(
        <div className="requsted-item-wrapper">

            <BasicModalWindow
                    shown={returnItemModal}
                    handleClose={closeReturnModal}
                    size="sm"
                    showHeader
                    title="Return Item"
                    actionButtonsBottom
                    actionButtons={[
                        {
                            label: "Return Item",
                            color: "success",
                            disabled: loading,
                            onClick: handleReturnItem,
                        },
                        {
                          label: "Cancel",
                          color: "error",
                          onClick: closeReturnModal
                      }
                    ]}
            >
                <TextField 
                    type="text"
                    label="Optional Note"
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    multiline
                    rows={4}
                    fullWidth
                />
            </BasicModalWindow>

            <ItemAllocations viewRequestPage={viewRequestPage} request={request} open={open} requestedItems={requestedItems} requestedItem={requestedItem} setItems={setItems} handleClose={() => setOpen(false)} updateAllocationsForItem={updateAllocationsForItem} />

            <div className="requsted-item-box-container">
                <div className="content-of-requsted-item-box-container">

                    <div className="fields-of-requsted-item-box-container">
                        <div className="content-of-fields-of-requsted-item-box-container">

                            <div className="field-of-requsted-item-box-container thumbnail">
                                <div className="content-of-field-of-requsted-item-box-container">
                                    {/* <Avatar src={item.thumbnail ? item.thumbnail : NoThumb}>
                                        <GenerateIcon icon="image" />
                                    </Avatar> */}
                                    <Thumbnail src={item.thumbnail ? item.thumbnail : NoThumb} />
                                </div>
                            </div>

                            <div className="field-of-requsted-item-box-container text" style={{ minWidth: 200, maxWidth: 200 }}>
                                <div className="content-of-field-of-requsted-item-box-container">
                                    <h4>Item</h4>
                                    {/* <a href={isItemRequestPage ? `/panel/items/view/${item.unique_id}` : `/items/${item.unique_id}`} target="_blank"><h3>{item.title}</h3></a> */}
                                    <h3 style={{ cursor: "pointer" }} onClick={() => {
                                        handleOpenElementQuickPreview(
                                            item.id,
                                            item.title,
                                            () => new ItemsApp(),
                                            dispatch,
                                            [
                                                {
                                                    label: "Close",
                                                    color: "error",
                                                    onClick: () => handleCloseElementQuickPreview(dispatch)
                                                }
                                            ],
                                            false,
                                            undefined,
                                            true
                                        )
                                    }}>{item.title}</h3>
                                </div>
                            </div>

                            <div className="field-of-requsted-item-box-container text" style={{ minWidth: 200, maxWidth: 200 }}>
                                <div className="content-of-field-of-requsted-item-box-container">
                                    <h4>Unique ID</h4>
                                    <h3>{item.unique_id}</h3>
                                </div>
                            </div>

                            <div className="field-of-requsted-item-box-container text" style={{ minWidth: 200, maxWidth: 200 }}>
                                <div className="content-of-field-of-requsted-item-box-container">
                                    <h4>Serial Number</h4>
                                    <h3>{item.serial_number ? item.serial_number : "-"}</h3>
                                </div>
                            </div>

                            <div className="field-of-requsted-item-box-container text" style={{ minWidth: 120, maxWidth: 120 }}>
                                <div className="content-of-field-of-requsted-item-box-container">
                                    <h4>Total Quantity</h4>
                                    <h3>{quantity}</h3>
                                </div>
                            </div>

                            {/* <div className="field-of-requsted-item-box-container text" style={{ minWidth: 120, maxWidth: 120 }}>
                                <div className="content-of-field-of-requsted-item-box-container">
                                    <h4>Damaged Quantity</h4>
                                    <h3>{damaged}</h3>
                                </div>
                            </div>

                            <div className="field-of-requsted-item-box-container text" style={{ minWidth: 120, maxWidth: 120 }}>
                                <div className="content-of-field-of-requsted-item-box-container">
                                    <h4>Missing Quantity</h4>
                                    <h3>{missing}</h3>
                                </div>
                            </div> */}

                        </div>
                    </div>

                    {/* {!viewRequestPage ? (
                      <div className="action-buttons-of-requsted-item-box-container">
                          <div className="content-of-action-buttons-of-requsted-item-box-container">

                              <Button className="general-button admin-button" color="success" onClick={() => setOpen(true)}>Update Quantity</Button>
                              <Button className="general-button admin-button" color="error" onClick={() => deleteItem(item_id)}>Delete</Button>

                          </div>
                      </div>
                    ) : (
                        <div className="action-buttons-of-requsted-item-box-container">
                            <div className="content-of-action-buttons-of-requsted-item-box-container">

                            {showReturnButton && <Button disabled={isReturnAvailbale ? false : true} className="general-button admin-button" color="success" onClick={() => setReturnItemModal(true)}>Return</Button>}
                            {showRejectButton && <Button disabled={requestedItem.is_rejected} className="general-button admin-button" color="error" onClick={() => handleShowRejectItem(requestedItem.item_id)}>Reject</Button>}

                            </div>
                        </div>
                    )} */}

                      <div className="action-buttons-of-requsted-item-box-container">
                          <div className="content-of-action-buttons-of-requsted-item-box-container">
                                {renderActionButtons()}
                          </div>
                      </div>



                </div>
            </div>

            {requestedItem.is_rejected && (
                <div className="requested-item-allocations-container error-note">
                    <div className="content-of-requested-item-allocations-container">
                        <AlertElement type="error" message={`${requestedItem.item.title} has been rejected from the request.`} />
                    </div>
                </div>
            )}

            {!hideAllocations && <RequestedItemAllocations request={request ? request : EmptyItemRequestModel} showReport={showReport} viewRequestPage={viewRequestPage} requestedItem={requestedItem} removeAllocationForItem={removeAllocationForItem} />}
            {!hideContainedItems && <RequestItemSubItems isItemRequestPage={isItemRequestPage} requestedItem={requestedItem} requestedItems={requestedItems} />}

        </div>
    )
}

interface ISelectRequestedItems {
    items: IRequestedItem[],
    setItems: (items: IRequestedItem[]) => void,
    viewRequestPage?: boolean,
    request?: ItemsRequestModel | null,
    forceRefreshRequest?: (status: boolean) => void,
    hideAllocations?: boolean,
    hideContainedItems?: boolean,
}

export default function SelectRequestedItems(props: ISelectRequestedItems) {

    const { 
        items, 
        setItems, 
        viewRequestPage, 
        request, 
        forceRefreshRequest,
        hideAllocations,
        hideContainedItems,
    } = props

    const [show, setShow] = useState<boolean>(false)
    const dispatch = useDispatch()

    const itemsApp = new ItemsApp()
    const itemsRequestsApp = new ItemsRequestsApp()

    const location = useLocation()
    const isItemRequestPage = location.pathname.includes("/panel/item_requests")

    const [reportModalStatus, setReportModalStatus] = useState<boolean>(false)

    const [warehouseId, setWarehouseId] = useState<number | null>(null)
    const [sectionId, setSectionId] = useState<number | null>(null)
    const [locationId, setLocationId] = useState<number | null>(null)

    const [allocatedWarehouseId, setAllocatedWarehouseId] = useState<number | null>(null)
    const [allocatedSectionId, setAllocatedSectionId] = useState<number | null>(null)
    const [allocatedLocationId, setAllocatedLocationId] = useState<number | null>(null)

    const [quantity, setQuantity] = useState<number | null>(null)
    const [maxQuantity, setMaxQuantity] = useState<number>(0)
    const [quantityModal, setQuantityModal] = useState<boolean>(false)
    const [itemId, setItemId] = useState<number | null>(null)
    const [requestNumber, setRequestNumber] = useState<string | null>(null)

    const [rejectItemModalStatus, setRejectItemModalStatus] = useState<boolean>(false)
    const [rejectItemId, setRejectItemId] = useState<number | null>(null)
    const [rejectNote, setRejectNote] = useState<string>("")
    const [loadingReject, setLoadingReject] = useState<boolean>(false)

    /**
     * Handle open modal
     */
    const handleOpenModal = () => setShow(true)

    /**
     * Handle close modal
     */
    const handleCloseModal = () => setShow(false)

    /**
     * Add items
     */
    // const addItems = async (selectedItems: IItemModel[]) => {
    //     const updatedRequestedItems: IRequestedItem[] = [...items]
      
    //     for (const item of selectedItems) {
    //         const alreadyExists = updatedRequestedItems.some(req => req.item_id === item.id)

    //         if (alreadyExists) continue
        
    //         // Fetch current inventory for the item
    //         const response = await itemsApp.itemInventory(item.unique_id)
    //         const inventoryData = response.data  // assuming response contains a list of { warehouse_id, section_id, quantity }
        
    //         const allocations: IRequestedItemAllocation[] = inventoryData.map((inv: any) => ({
    //             warehouseId: inv.warehouse_id,
    //             sectionId: inv.section_id,
    //             quantity: inv.quantity,
    //         }))
        
    //         const totalQuantity = allocations.reduce((sum, alloc) => sum + alloc.quantity, 0)
        
    //         updatedRequestedItems.push({
    //             item_id: item.id,
    //             item: item,
    //             quantity: totalQuantity,
    //             allocations: allocations,
    //         })

    //     }
      
    //     setItems(updatedRequestedItems)
    //     handleCloseModal()
    // }
    const addItemsOld = async (selectedItems: IItemModel[]) => {
        const updatedRequestedItems: IRequestedItem[] = [...items]
      
        for (const item of selectedItems) {
          const alreadyExists = updatedRequestedItems.some(req => req.item_id === item.id)
          if (alreadyExists) continue
      
          // 🔍 Check if this is a container (custom logic – maybe `item.is_container` or `item.type === 'container'`)
          const isContainer = item.is_container
      
          // 🔄 Fetch inventory for this item
          const response = await itemsApp.itemInventory(item.unique_id)
          const inventoryData = response.data
      
          // const allocations: IRequestedItemAllocation[] = inventoryData.map((inv: any) => ({
          //   warehouseId: inv.warehouse_id,
          //   sectionId: inv.section_id,
          //   quantity: inv.quantity,
          // }))

          let allocations: IRequestedItemAllocation[] = []

          inventoryData.map((inv: any) => {
              if (inv){

                  if (inv.user_id){
                      return;
                  }

                  if (inv.quantity > 0){
                      allocations.push({
                        warehouseId: inv.warehouse_id,
                        sectionId: inv.section_id,
                        quantity: inv.quantity,
                        locationId: inv.location_id,
                        is_rejected: false,
                        is_returned: false,
                        missing_qnt: 0,
                        damaged_qnt: 0
                      })
                  }
              }
          })

      
          const totalQuantity = allocations.reduce((sum, alloc) => sum + alloc.quantity, 0)

          if (totalQuantity === 0) continue

      
          // ✅ Add container or standalone item
          updatedRequestedItems.push({
            item_id: item.id,
            item: item,
            quantity: totalQuantity,
            allocations: allocations,
            damaged: 0,
            missing: 0,
            is_rejected: false,
            is_returned: false,
          })
      
          // 📦 If it's a container, load its children
          if (isContainer) {
            try {
              const containerRes = await itemsApp.returnContainerItemList(item.id)
              const containerItems = containerRes.data || []
      
              containerItems.forEach((child: IItemModel) => {
                const childExists = updatedRequestedItems.some(req => req.item_id === child.id)
                if (childExists) return
      
                updatedRequestedItems.push({
                  item_id: child.id,
                  item: child,
                  quantity: child.quantity || 1, // You can improve this if container item includes quantity
                  missing: 0,
                  damaged: 0,
                  is_rejected: false,
                  is_returned: false,
                  allocations: [
                    {
                      warehouseId: allocations[0]?.warehouseId,
                      sectionId: allocations[0]?.sectionId,
                      locationId: allocations[0]?.locationId,
                      quantity: child.quantity || 1,
                    },
                  ],
                })
              })
            } catch (error) {
              console.error("Failed to fetch container items:", error)
            }
          }
        }
      
        setItems(updatedRequestedItems)
        handleCloseModal()
      }

    const addItems = async (selectedItems: ISelectedItemForRequestModel[], doSomething?: () => void) => {
        
        let list: IRequestedItem[] = []

        if (selectedItems.length > 0) {
            for (const selectedItem of selectedItems) {
                if (items.find((item) => item.item_id === selectedItem.id)) {
                    continue;
                }

                const totalQuantity = selectedItem.allocations.reduce((sum, allocation) => {
                    return sum + allocation.quantity;
                }, 0);

                let filteredAllocations = selectedItem.allocations.filter(
                    (allocation) => allocation.quantity !== 0
                );

                list.push({
                    item_id: selectedItem.id,
                    item: selectedItem,
                    allocations: filteredAllocations,
                    quantity: totalQuantity,
                    damaged: 0,
                    missing: 0,
                    is_rejected: false,
                    is_returned: false,
                });

                if (selectedItem.is_container) {
                    try {
                        const containerRes = await itemsApp.returnContainerItemList(selectedItem.id);
                        const containerItems = containerRes.data || [];

                        containerItems.forEach((child: IItemModel) => {
                            const childExists = list.some((req) => req.item_id === child.id);
                            if (childExists) return;

                            list.push({
                                item_id: child.id,
                                item: child,
                                quantity: child.quantity || 1,
                                missing: 0,
                                damaged: 0,
                                is_rejected: false,
                                is_returned: false,
                                allocations: [
                                    {
                                        warehouseId: filteredAllocations[0]?.warehouseId,
                                        sectionId: filteredAllocations[0]?.sectionId,
                                        locationId: filteredAllocations[0]?.locationId,
                                        quantity: child.quantity || 1,
                                    },
                                ],
                            });
                        });
                    } catch (error) {
                        console.error("Failed to fetch container items:", error);
                    }
                }
            }

        }

        const complete = (items: IRequestedItem[]) => {
            setItems(items)

            if (doSomething) {
                doSomething();
            } else {
                handleCloseModal();
            }
        }

        if (request && request.status === "pending"){

            itemsRequestsApp.addItemsToRequest(request.request_number, list)
                .then(response => {

                    const { data } = response
                    const createdItems: IRequestedItem[] = data.items

                    complete([...createdItems, ...items])

                })
                .catch(error => {
                    handleRequestError(error, dispatch)
                })

        }else{
            complete([...items, ...list])
        }

    }

    /**
     * Delete item
     */

    const handleDeleteItemFromState = (id: number) => {
        const updatedItems = items.filter(item => item.item_id !== id)
        setItems(updatedItems)
    }

    const deleteItem = (id: number) => {
        if (request){

            if (request.status === "pending"){
                itemsRequestsApp.deleteRequestedItem(request.request_number, id)
                    .then(response => {
                        handleDeleteItemFromState(id)
                    })
                    .catch(error => {
                        handleRequestError(error, dispatch)
                    })
            }

        }else{
            handleDeleteItemFromState(id)
        }
    }

    /**
     * Update item quantity
     */
    const updateRequestedItemQuantity = (itemId: number, newQuantity: number) => {
        const updatedItems = items.map(item => {
          if (item.item_id === itemId) {
            return {
              ...item,
              quantity: newQuantity
            }
          }
          return item
        })
      
        setItems(updatedItems)
    }

    /**
     * Update allocations
     */
    const updateAllocationsForItem = (
        itemId: number,
        updatedAllocation: IRequestedItemAllocation
    ) => {
        const updatedItems = items.map(item => {
            if (item.item_id === itemId) {
              const existingIndex = item.allocations.findIndex(
                alloc =>
                  alloc.warehouseId === updatedAllocation.warehouseId &&
                  alloc.sectionId === updatedAllocation.sectionId
              )
        
              let updatedAllocations = [...item.allocations]
        
              if (existingIndex !== -1) {
                updatedAllocations[existingIndex] = updatedAllocation
              } else {
                updatedAllocations.push(updatedAllocation)
              }
        
              // 🔢 Recalculate total quantity from allocations
              const newTotalQuantity = updatedAllocations.reduce(
                (sum, alloc) => sum + alloc.quantity,
                0
              )
        
              return {
                ...item,
                allocations: updatedAllocations,
                quantity: newTotalQuantity
              }
            }
        
            return item
          })
        
          setItems(updatedItems)
    }

    const removeAllocationForItem = (
        itemId: number,
        warehouseId: number,
        sectionId: number
      ) => {
            const executeRemoveAllocationForItem = () => {
                const updatedItems = items.map(item => {
                    if (item.item_id === itemId) {
                        // Filter out the matching allocation
                        const updatedAllocations = item.allocations.filter(
                        alloc =>
                            !(alloc.warehouseId === warehouseId && alloc.sectionId === sectionId)
                        )
                
                        // Recalculate total quantity
                        const newQuantity = updatedAllocations.reduce(
                        (sum, alloc) => sum + alloc.quantity,
                        0
                        )
                
                        return {
                            ...item,
                            allocations: updatedAllocations,
                            quantity: newQuantity
                        }
                    }
                
                    return item
                })
            
                setItems(updatedItems)

            }

            if (!request){
                executeRemoveAllocationForItem()
            }else{
                if (request.status === "pending"){

                    itemsRequestsApp.clearRequestedItemAllocations(request.request_number, itemId, warehouseId, sectionId)
                        .then(response => {
                            executeRemoveAllocationForItem()
                        })
                        .catch(error => {
                            handleRequestError(error, dispatch)
                        })

                }
            }

    }

    /**
     * Show report
     */
    const showReport = (requestedItem: IRequestedItem, allocation: IRequestedItemAllocation) => {
          setItemId(requestedItem.item_id)
          setRequestNumber(requestedItem.request_number ? requestedItem.request_number : "")

          setAllocatedWarehouseId(allocation.warehouseId)
          setAllocatedSectionId(allocation.sectionId)

          if (request){
              setLocationId(request.destination_location)
              setWarehouseId(request.destination_warehouse)
              setSectionId(request.destination_section)
          }

          if (allocation.quantity === 1){
              setQuantity(allocation.quantity)
              setReportModalStatus(true)
          }else{
              setQuantityModal(true)
              setMaxQuantity(allocation.quantity)
          }

          // setReportModalStatus(true)

          // if (request){

          //     if (request.designation_type === "location"){
          //         setQuantityModal(true)

          //         setLocationId(request.destination_location)
          //     }else{
          //         setReportModalStatus(true)
          //     }

          // }

    }

    /**
     * Show issue modal
     */
    const showIssueModal = () => {
        setReportModalStatus(true)
    }

    /**
     * Handle close report modal
     */
    const handleCloseReportModal = () => {
        setReportModalStatus(false)
    }

    /**
     * Handle close quantity modal
     */
    const handleCloseQuantityModal = () => {
        setQuantityModal(false)
        setQuantity(0)
        setMaxQuantity(0)
    }

    /**
     * Handle close reject item
     */
    const handleCloseRejectItem = () => {
        setRejectItemModalStatus(false)
        setRejectItemId(null)
    }

    /**
     * Reject item
     */
    const handleRejectItem = () => {
        if (!rejectItemId){
            return;
        }

        if (!request){
            return;
        }

        setLoadingReject(true)

        itemsRequestsApp.rejectRequestedItem(request.request_number, rejectItemId, rejectNote)
            .then(response => {
                if (forceRefreshRequest){
                    forceRefreshRequest(true)
                }
                setLoadingReject(false)
                handleCloseRejectItem()
            })
            .catch(error => {
                handleRequestError(error, dispatch)
                setLoadingReject(false)
                handleCloseRejectItem()
            })

    }

    /**
     * handleShowRejectItem
     */
    const handleShowRejectItem = (itemId: number) => {
        setRejectItemId(itemId)
        setRejectItemModalStatus(true)
    }

    return(
        <SectionBoxContainer
          showTitle
          title={`Requested Items (${items.length})`}
          addButton={() => {

              return <Button className="general-button admin-button light-button" startIcon={<GenerateIcon icon="new" />} onClick={() => handleOpenModal()} style={{ height: 35, marginLeft: 5 }} color="success">Add item</Button>
          }}
          noWrap={request && request.status === "pending" ? false : viewRequestPage ? true : false}
        >
            <div className="requested-items-container">

                <BasicModalWindow
                    shown={rejectItemModalStatus}
                    handleClose={handleCloseRejectItem}
                    size="sm"
                    showHeader
                    title="Reject Item"
                    actionButtonsBottom
                    actionButtons={[
                        {
                            label: "Reject",
                            color: "success",
                            onClick: handleRejectItem,
                            disabled: loadingReject ? false : rejectItemId ? false : true
                        },
                        {
                          label: "Cancel",
                          color: "error",
                          onClick: handleCloseRejectItem
                      }
                    ]}
                >
                    <TextField 
                        type="text"
                        label="Optional Note"
                        value={rejectNote}
                        onChange={(e) => setRejectNote(e.target.value)}
                        multiline
                        rows={4}
                        fullWidth
                    />
                </BasicModalWindow>

                <BasicModalWindow
                    shown={quantityModal}
                    handleClose={handleCloseQuantityModal}
                    size="sm"
                    showHeader
                    title="Select Quantity"
                    actionButtonsBottom
                    actionButtons={[
                        {
                            label: "Done",
                            color: "success",
                            onClick: showIssueModal,
                            disabled: quantity ? quantity === 0 ? true : false : true
                        },
                        {
                          label: "Cancel",
                          color: "error",
                          onClick: handleCloseQuantityModal
                      }
                    ]}
                >
                      <QuantitySlider itemMaxAvailableQnt={maxQuantity} quantity={quantity ? quantity : 0} updateQuantity={(qnt) => setQuantity(qnt)} />
                </BasicModalWindow>

                <BasicModalWindow
                    shown={reportModalStatus}
                    handleClose={handleCloseReportModal}
                    size="fullscreen"
                    showHeader
                    title="Report Issue"
                    actionButtons={[]}
                >
                    <CreateNewIssue  
                        itemId={itemId ? itemId : 0}
                        requestNumber={requestNumber ? requestNumber : ""}

                        customWarehouseId={warehouseId}
                        customSectionId={sectionId}
                        customLocationId={locationId}

                        allocatedWarehouseId={allocatedWarehouseId}
                        allocatedSectionId={allocatedSectionId}
                        allocatedLocationId={allocatedLocationId}

                        customQuantity={quantity}

                        doAfterCreate={(issue) => {
                            window.location.reload()
                        }}
                    />
                </BasicModalWindow>

                <SelectItemsForRequest request={request} show={show} handleCloseModal={handleCloseModal} addItems={addItems} />

                <div className="content-of-requested-items-container">

                    <div className="requested-items-list">
                        {items.map((item, index) => <RequestedItem hideAllocations={hideAllocations} hideContainedItems={hideContainedItems} forceRefreshRequest={forceRefreshRequest} handleShowRejectItem={handleShowRejectItem} request={request} showReport={showReport} isItemRequestPage={isItemRequestPage} viewRequestPage={viewRequestPage} requestedItems={items} requestedItem={item} key={index} deleteItem={deleteItem} setItems={setItems} updateAllocationsForItem={updateAllocationsForItem} removeAllocationForItem={removeAllocationForItem} />)}
                    </div>

                </div>

            </div>
        </SectionBoxContainer>
    )
}